/* eslint-disable no-undef */
/* global EmblaCarousel */
const players = [];

const setupEmblaDotBtns = (dotsArray, embla) => {
  dotsArray.forEach((dotNode, i) => {
    dotNode.addEventListener("click", () => embla.scrollTo(i), false);
  });
};

const generateEmblaDotBtns = (dots, embla) => {
   if (!dots || !embla) return [];
  const template = document.getElementById("embla-dot-section").innerHTML;
  if(!template) return;
  const dotsInnerHtml = dots;

  dotsInnerHtml.innerHTML = embla
    .scrollSnapList()
    .reduce((acc) => acc + template, "");

  return [].slice.call(dots.querySelectorAll(".featured-embla__dot"));
};

const selectEmblaDotBtn = (dotsArray, embla) => () => {
  const previous = embla.previousScrollSnap();
  const selected = embla.selectedScrollSnap();

  dotsArray[previous]?.classList.remove("is-selected");
  dotsArray[selected]?.classList.add("is-selected");
};

const onThumbClick = (mainCarousel, thumbCarousel, index) => () => {
  if (!thumbCarousel.clickAllowed()) return;
  mainCarousel.scrollTo(index);
};

const pauseVideo = () => {
  const htmlVideoPlayers = document.querySelectorAll(
    ".product-single__media video"
  );

  htmlVideoPlayers.forEach((player) => {
    player.pause();
  });

  players.forEach((player) => {
    player.pauseVideo();
  });
};

const playVideo = () => {
  const selectedYoutubeVideo = document.querySelector(
    ".is-selected .product-single__media"
  );
  const selectedHtmlVideo = selectedYoutubeVideo.querySelector("video");

  if (selectedYoutubeVideo) {
    const { videoHost, videoId } = selectedYoutubeVideo.dataset;

    if (videoHost === "youtube") {
      players.forEach((player) => {
        if (player.playerInfo.videoData.video_id === videoId) {
          player.playVideo();
          player.unMute();
        }
      });
    }

    if (selectedHtmlVideo) selectedHtmlVideo.play();
  }
};

const selectThumbBtn = (mainCarousel, thumbCarousel) => {
  const previous = mainCarousel.previousScrollSnap();
  const selected = mainCarousel.selectedScrollSnap();

  mainCarousel.slideNodes()[previous].classList.remove("is-selected");
  mainCarousel.slideNodes()[selected].classList.add("is-selected");
  thumbCarousel.slideNodes()[previous].classList.remove("is-selected");
  thumbCarousel.slideNodes()[selected].classList.add("is-selected");

  pauseVideo();
  playVideo();
};

const followMainCarousel = (mainCarousel, thumbCarousel) => () => {
  thumbCarousel.scrollTo(mainCarousel.selectedScrollSnap());
  selectThumbBtn(mainCarousel, thumbCarousel);
};

const loadYoutubeScript = () => {
  // eslint-disable-next-line no-undef
  if (typeof YT === "undefined" || typeof YT.Player === "undefined") {
    const tag = document.createElement("script");
    const firstScriptTag = document.getElementsByTagName("script")[0];

    tag.src = "https://www.youtube.com/iframe_api";
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
  }
};

const onPlayerReady = (event) => {
  event.target.mute();
};

function initializeYoutubeMedia() {
  const productMediaWrapper = document.querySelectorAll(
    ".product-single__media"
  );

  productMediaWrapper.forEach((media) => {
    const { videoHost, videoId } = media.dataset;

    if (videoHost === "youtube") {
      const iframe = media.querySelector("iframe");
      const newPlayer = new YT.Player(iframe, {
        playerVars: { autoplay: 1, playsinline: 1 },
        videoId,
        events: {
          onReady: onPlayerReady,
        },
      });

      players.push(newPlayer);
    }
  });
}

const setupPrevNextBtns = (prevBtn, nextBtn, embla) => {
  if (prevBtn && nextBtn && embla) {
  prevBtn.addEventListener("click", embla.scrollPrev, false);
  nextBtn.addEventListener("click", embla.scrollNext, false);
  }
};

const disablePrevNextBtns = (prevBtn, nextBtn, embla) => {
  return () => {
    if (prevBtn) {
    if (embla.canScrollPrev()) prevBtn.removeAttribute("disabled");
    else prevBtn.setAttribute("disabled", "disabled");
    }
if (nextBtn) {
    if (embla.canScrollNext()) nextBtn.removeAttribute("disabled");
    else nextBtn.setAttribute("disabled", "disabled");
  };
  }
};

const EmblaInitialize = (emblaClass = "") => {
  const mediaQuery = window.matchMedia("(max-width: 767px)");
  //if (mediaQuery.matches) {
  //if (window.innerWidth <= 767 ) {
  document.querySelectorAll(".embla").forEach((slider) => {
    const sliderCardCount = slider.querySelectorAll(".embla__slide").length;

    if (slider) {
      const mobileOptions = {
        loop: true,
        skipSnaps: false,
        containScroll: "trimSnaps",
        align: "start",
        //startIndex: 0,
        slidesToScroll: 1,
        draggable: true,
        dragFree: false,
      };

      let desktopOptions = {
        loop: true,
        skipSnaps: false,
        containScroll: "trimSnaps",
        align: "start",
        startIndex: 0,
        slidesToScroll: 1,
        draggable: true,
        dragFree: false,
      };

      const options = window.innerWidth <= 767 ? mobileOptions : desktopOptions;

      const sliderCardCount = slider.querySelectorAll(".embla__slide").length;
      if (sliderCardCount) {
        if (window.innerWidth <= 767 || window.innerWidth > 1100) {
          const viewPort = slider.querySelector(".embla__viewport");
          const dots = slider.querySelector(".featured-embla__dots");
          const embla = new EmblaCarousel(viewPort, options);

          if (window.innerWidth > 768) {
            embla.rewind = false;
          } else {
            embla.rewind = true;
          }

          const dotsArray = generateEmblaDotBtns(dots, embla);
          const setSelectedDotBtn = selectEmblaDotBtn(dotsArray, embla);

          setupEmblaDotBtns(dotsArray, embla);
          embla.on("select", setSelectedDotBtn);
          embla.on("init", setSelectedDotBtn);

          const prevBtn = slider.querySelector(".embla__button--prev");
          const nextBtn = slider.querySelector(".embla__button--next");

          const disablePrevAndNextBtns = disablePrevNextBtns(
            prevBtn,
            nextBtn,
            embla
          );
          setupPrevNextBtns(prevBtn, nextBtn, embla);

          embla.on("select", disablePrevAndNextBtns);
          embla.on("init", disablePrevAndNextBtns);

          embla.on('resize', () => {
          embla.destroy();
          EmblaInitialize();
        });
        }
      }
    }
  });

  document.querySelectorAll(".logo_embla").forEach((slider) => {
    if (slider) {
      const options = {
        loop: true,
        skipSnaps: false,
        containScroll: "trimSnaps",
        align: "start",
        startIndex: 0,
        slidesToScroll: 3,
        draggable: true,
        dragFree: false,
      };
      const sliderCardCount = slider.querySelectorAll(".embla__slide").length;

      if (window.innerWidth <= 767) {
        const viewPort = slider.querySelector(".embla__viewport");
        const dots = slider.querySelector(".featured-embla__dots");
        const embla = new EmblaCarousel(viewPort, options);

        const dotsArray = generateEmblaDotBtns(dots, embla);
        const setSelectedDotBtn = selectEmblaDotBtn(dotsArray, embla);

        setupEmblaDotBtns(dotsArray, embla);
        embla.on("select", setSelectedDotBtn);
        embla.on("init", setSelectedDotBtn);

        const prevBtn = slider.querySelector(".embla__button--prev");
        const nextBtn = slider.querySelector(".embla__button--next");

        const disablePrevAndNextBtns = disablePrevNextBtns(
          prevBtn,
          nextBtn,
          embla
        );
        setupPrevNextBtns(prevBtn, nextBtn, embla);

        embla.on("select", disablePrevAndNextBtns);
        embla.on("init", disablePrevAndNextBtns);
      }
    }
  });
  //}

  document.querySelectorAll(".reviews-embla").forEach((slider) => {
    if (slider) {
      const options = {
        align: "center",
        startIndex: 0,
        slidesToScroll: 1,
        draggable: true,
        dragFree: false,
        loop: true,
      };
      const sliderCardCount = slider.querySelectorAll(".embla__slide").length;

      const viewPort = slider.querySelector(".embla__viewport");
      const dots = slider.querySelector(".featured-embla__dots");
      const embla = new EmblaCarousel(viewPort, options);

      const dotsArray = generateEmblaDotBtns(dots, embla);
      const setSelectedDotBtn = selectEmblaDotBtn(dotsArray, embla);

      setupEmblaDotBtns(dotsArray, embla);
      embla.on("select", setSelectedDotBtn);
      embla.on("init", setSelectedDotBtn);

      const prevBtn = slider.querySelector(".embla__button--prev");
      const nextBtn = slider.querySelector(".embla__button--next");

      const disablePrevAndNextBtns = disablePrevNextBtns(
        prevBtn,
        nextBtn,
        embla
      );
      setupPrevNextBtns(prevBtn, nextBtn, embla);

      embla.on("select", disablePrevAndNextBtns);
      embla.on("init", disablePrevAndNextBtns);
    }
  });
};

EmblaInitialize();

window.initializeEmblaSlider = EmblaInitialize;
